export default {
  stats: {
    orders: 'Comenzi',
    sales: 'Venituri',
  },
};
